import { OpgaveBedoemmesAfEnum } from '../enums/OpgaveBedoemmesAfEnum';
import { BrugerRolleEnum } from '../enums/BrugerRolleEnum';

export default function bedoemmesAfTilRolleMap(bedoemmesAf: OpgaveBedoemmesAfEnum): BrugerRolleEnum[] {
    switch (bedoemmesAf) {
        case OpgaveBedoemmesAfEnum.EksterneLaerer:
            return [BrugerRolleEnum.Laerer, BrugerRolleEnum.Ekstern];
        case OpgaveBedoemmesAfEnum.Elever:
            return [BrugerRolleEnum.Elev];
        case OpgaveBedoemmesAfEnum.Piloter:
            return [BrugerRolleEnum.Administrator];
        default:
            throw Error('Ukendt OpgaveBedoemmesAfEnum værdi: ' + bedoemmesAf);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/mappers/BedoemmesAfTilRolleMap.ts